module.exports = __webpack_public_path__ + "static/media/MyZoneColorLogo.b458724f.svg";